
@if (showLogin) {
  <div>
    <router-outlet></router-outlet>
  </div>
}

@if (showContent) {
  <div class="flex-container">
    <div id="nav-block" class="nav-block">
      <nav class="nav-container">
        <div class="nav-full" [hidden]="navHidden">
          <nav-menu></nav-menu>
        </div>
        <div class="nav-min" (click)="hideShowNav()"></div>
      </nav>
    </div>
    <div id="closed-nav-min" class="nav-min-closed" (click)="hideShowNav()"></div>
    <div class="main-content">
      <breadcrumbs></breadcrumbs>
      <message></message>
      <div class="page-content">
        @if (showNotActivatedError) {
          <p-messages [(value)]="notActivatedError" [closable]="false"></p-messages>
        }
        @if (showGracePeriodError) {
          <p-messages [(value)]="gracePeriodError" [closable]="false"></p-messages>
        }
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}